import React from "react";

import { useFetchQuery } from "../../hooks/useFetchQuery";
import RenderHTML from "../../components/RenderHTML/RenderHTML";
import {
  ViewHeader2,
  ViewHeader,
  ViewTitle,
} from "../../components/ViewStyle/ViewStyle";
import PageButtons from "../../components/ExtraButtons/ExtraButtons";
import {
  Text,
  Container,
  Box,
  Image,
  SimpleGrid,
  VStack,
  Flex,
} from "@chakra-ui/react";

export default function WelcomeDesktop({
  viewData,
  link,
  showCaption,
  showSubTitle,
  anchorID,
  queryKey,
}: Record<string, any>): JSX.Element {
  // get data

  const { data } = useFetchQuery(queryKey, link);

  const welcomeInfo = data.data;
  const content = welcomeInfo.content;

  const config = viewData.config;

  return (
    <section
      role="main"
      aria-label="Welcome Desktop"
      style={{
        padding: "3rem 0rem",
      }}
      id={anchorID}
    >
      <Container
        id="Welcome Message"
        maxWidth="1100px"
        marginTop="20px"
      >
        <ViewHeader
          role="heading"
          titleColor={config.titleColor}
          style={{
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {viewData.title}
        </ViewHeader>
        {showSubTitle ? (
          <Box>
            <ViewHeader2
              role="heading"
              titleColor={config.titleColor}
              style={{
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              {viewData.subTitle}
            </ViewHeader2>

            <ViewTitle role="heading">{viewData.characteristics}</ViewTitle>
          </Box>
        ) : null}

        <SimpleGrid
          columns={[1, 1, 1, 2]}
          spacing="8px"
          padding="25px"
        >
          <RenderHTML content={content}></RenderHTML>

          {welcomeInfo.images.length > 0 && (
            <VStack
              role="group"
              id="imageandcaption"
              align="center"
            >
              <Image
                alt={viewData.imageCaption}
                src={welcomeInfo.images[0].large}
                maxWidth={config.imgWidth ? config.imgWidth : "250px"}
              ></Image>

              {showCaption ? (
                <Flex>
                  <Text
                    textTransform="uppercase"
                    textAlign="center"
                    justifySelf="center"
                    fontSize="1.125rem"
                    fontFamily="Roboto"
                  >
                    {viewData.imageCaption}
                  </Text>
                </Flex>
              ) : null}
            </VStack>
          )}
        </SimpleGrid>
        {config && config.showButtons && (
          <PageButtons
            config={config}
            pageData={welcomeInfo}
          />
        )}
      </Container>
    </section>
  );
}
